import { UserRole } from '@/types/types';
import { NAV_ROUTES } from '@/utils/constants';

export const UsersRoleRedirectMap: Record<UserRole, string> = {
  admin: NAV_ROUTES.connectors,
  editor: NAV_ROUTES.connectors,
  viewer: NAV_ROUTES.connectors,
  dashboard_viewer: NAV_ROUTES.dashboards,
};
